import { render, staticRenderFns } from "./personnel_govem.vue?vue&type=template&id=7ba84f60&scoped=true&"
import script from "./personnel_govem.vue?vue&type=script&lang=js&"
export * from "./personnel_govem.vue?vue&type=script&lang=js&"
import style0 from "./personnel_govem.vue?vue&type=style&index=0&id=7ba84f60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba84f60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCardText,VContainer,VIcon,VSnackbar})
